import { AffiliateApi } from "@/api/affiliates";
import { QueryKey } from "@/utils";
import { useQuery } from "@tanstack/react-query";

export const useGetMe = () => {
  const { data, isPending, isError } = useQuery({
    queryKey: [QueryKey.ME],
    queryFn: () => AffiliateApi.getMe(),
  });

  return { me: data, isMeLoading: isPending, isMeError: isError };
};
